export default __webpack_public_path__ + "static/media/logo-tp.478da755.svg";